/**
 * @function insert
 * @since 1.0.0
 */
export function append(array, value) {
    const index = array.indexOf(value);
    if (index == -1) {
        array.push(value);
    }
    return array;
}
/**
 * @function insert
 * @since 1.0.0
 */
export function insert(array, value, at) {
    const index = array.indexOf(value);
    if (index == -1) {
        array.splice(at, 0, value);
    }
    return array;
}
/**
 * @function remove
 * @since 1.0.0
 */
export function remove(array, value) {
    if (value == null) {
        return array;
    }
    const index = array.indexOf(value);
    if (index > -1) {
        array.splice(index, 1);
    }
    return array;
}
/**
 * @function update
 * @since 1.0.0
 */
export function update(array, value, index) {
    // array[index] = { ...array[index], ...value }
    array[index] = value;
    return array;
}
/**
 * @function splice
 * @since 1.0.0
 */
export function splice(array, index) {
    array.splice(index, 1);
    return array;
}
/**
 * @function concat
 * @since 1.0.0
 */
export function concat(array, value) {
    array.concat(value);
    return array;
}
/**
 * @function exists
 * @since 1.0.0
 */
export function exists(array, value) {
    return array.indexOf(value) > -1;
}
/**
 * @function shift
 * @since 1.0.0
 */
export function shift(array) {
    array.shift();
    return array;
}
/**
 * @function combine
 * @since 1.0.0
 */
export function combine(...arrays) {
    const length = Math.max(...arrays.map((array) => array.length));
    const output = new Array(length);
    for (let i = 0; i < length; i++) {
        output[i] = [];
        for (let j = 0; j < arrays.length; j++) {
            output[i].push(arrays[j][i]);
        }
    }
    return output;
}
export function first(array, predicate) {
    for (let i = 0; i < array.length; i++) {
        const result = predicate(array[i], i);
        if (result) {
            return result;
        }
    }
    return null;
}
